'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _toConsumableArray2 = require('babel-runtime/helpers/toConsumableArray');

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

var _regenerator = require('babel-runtime/regenerator');

var _regenerator2 = _interopRequireDefault(_regenerator);

var _bluebird = require('bluebird');

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _index = require('../../../index');

var _index2 = _interopRequireDefault(_index);

var _languageHandler = require('../../../languageHandler');

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _dispatcher = require('../../../dispatcher');

var _dispatcher2 = _interopRequireDefault(_dispatcher);

var _DateUtils = require('../../../DateUtils');

var _matrixJsSdk = require('matrix-js-sdk');

var _matrixTo = require('../../../matrix-to');

var _SettingsStore = require('../../../settings/SettingsStore');

var _SettingsStore2 = _interopRequireDefault(_SettingsStore);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// This component does no cycle detection, simply because the only way to make such a cycle would be to
// craft event_id's, using a homeserver that generates predictable event IDs; even then the impact would
// be low as each event being loaded (after the first) is triggered by an explicit user action.
var ReplyThread = function (_React$Component) {
    (0, _inherits3.default)(ReplyThread, _React$Component);

    function ReplyThread(props, context) {
        (0, _classCallCheck3.default)(this, ReplyThread);

        var _this = (0, _possibleConstructorReturn3.default)(this, (ReplyThread.__proto__ || (0, _getPrototypeOf2.default)(ReplyThread)).call(this, props, context));

        _this.state = {
            // The loaded events to be rendered as linear-replies
            events: [],

            // The latest loaded event which has not yet been shown
            loadedEv: null,
            // Whether the component is still loading more events
            loading: true,

            // Whether as error was encountered fetching a replied to event.
            err: false
        };

        _this.onQuoteClick = _this.onQuoteClick.bind(_this);
        _this.canCollapse = _this.canCollapse.bind(_this);
        _this.collapse = _this.collapse.bind(_this);
        return _this;
    }

    (0, _createClass3.default)(ReplyThread, [{
        key: 'componentWillMount',
        value: function componentWillMount() {
            this.unmounted = false;
            this.room = this.context.matrixClient.getRoom(this.props.parentEv.getRoomId());
            this.initialize();
        }
    }, {
        key: 'componentDidUpdate',
        value: function componentDidUpdate() {
            this.props.onHeightChanged();
        }
    }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
            this.unmounted = true;
        }
    }, {
        key: 'initialize',
        value: function () {
            var _ref = (0, _bluebird.coroutine)( /*#__PURE__*/_regenerator2.default.mark(function _callee() {
                var parentEv, ev;
                return _regenerator2.default.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                parentEv = this.props.parentEv;
                                // at time of making this component we checked that props.parentEv has a parentEventId

                                _context.next = 3;
                                return (0, _bluebird.resolve)(this.getEvent(ReplyThread.getParentEventId(parentEv)));

                            case 3:
                                ev = _context.sent;

                                if (!this.unmounted) {
                                    _context.next = 6;
                                    break;
                                }

                                return _context.abrupt('return');

                            case 6:

                                if (ev) {
                                    this.setState({
                                        events: [ev]
                                    }, this.loadNextEvent);
                                } else {
                                    this.setState({ err: true });
                                }

                            case 7:
                            case 'end':
                                return _context.stop();
                        }
                    }
                }, _callee, this);
            }));

            function initialize() {
                return _ref.apply(this, arguments);
            }

            return initialize;
        }()
    }, {
        key: 'loadNextEvent',
        value: function () {
            var _ref2 = (0, _bluebird.coroutine)( /*#__PURE__*/_regenerator2.default.mark(function _callee2() {
                var ev, inReplyToEventId, loadedEv;
                return _regenerator2.default.wrap(function _callee2$(_context2) {
                    while (1) {
                        switch (_context2.prev = _context2.next) {
                            case 0:
                                if (!this.unmounted) {
                                    _context2.next = 2;
                                    break;
                                }

                                return _context2.abrupt('return');

                            case 2:
                                ev = this.state.events[0];
                                inReplyToEventId = ReplyThread.getParentEventId(ev);

                                if (inReplyToEventId) {
                                    _context2.next = 7;
                                    break;
                                }

                                this.setState({
                                    loading: false
                                });
                                return _context2.abrupt('return');

                            case 7:
                                _context2.next = 9;
                                return (0, _bluebird.resolve)(this.getEvent(inReplyToEventId));

                            case 9:
                                loadedEv = _context2.sent;

                                if (!this.unmounted) {
                                    _context2.next = 12;
                                    break;
                                }

                                return _context2.abrupt('return');

                            case 12:

                                if (loadedEv) {
                                    this.setState({ loadedEv: loadedEv });
                                } else {
                                    this.setState({ err: true });
                                }

                            case 13:
                            case 'end':
                                return _context2.stop();
                        }
                    }
                }, _callee2, this);
            }));

            function loadNextEvent() {
                return _ref2.apply(this, arguments);
            }

            return loadNextEvent;
        }()
    }, {
        key: 'getEvent',
        value: function () {
            var _ref3 = (0, _bluebird.coroutine)( /*#__PURE__*/_regenerator2.default.mark(function _callee3(eventId) {
                var event;
                return _regenerator2.default.wrap(function _callee3$(_context3) {
                    while (1) {
                        switch (_context3.prev = _context3.next) {
                            case 0:
                                event = this.room.findEventById(eventId);

                                if (!event) {
                                    _context3.next = 3;
                                    break;
                                }

                                return _context3.abrupt('return', event);

                            case 3:
                                _context3.prev = 3;
                                _context3.next = 6;
                                return (0, _bluebird.resolve)(this.context.matrixClient.getEventTimeline(this.room.getUnfilteredTimelineSet(), eventId));

                            case 6:
                                _context3.next = 11;
                                break;

                            case 8:
                                _context3.prev = 8;
                                _context3.t0 = _context3['catch'](3);
                                return _context3.abrupt('return', null);

                            case 11:
                                return _context3.abrupt('return', this.room.findEventById(eventId));

                            case 12:
                            case 'end':
                                return _context3.stop();
                        }
                    }
                }, _callee3, this, [[3, 8]]);
            }));

            function getEvent(_x) {
                return _ref3.apply(this, arguments);
            }

            return getEvent;
        }()
    }, {
        key: 'canCollapse',
        value: function canCollapse() {
            return this.state.events.length > 1;
        }
    }, {
        key: 'collapse',
        value: function collapse() {
            this.initialize();
        }
    }, {
        key: 'onQuoteClick',
        value: function onQuoteClick() {
            var events = [this.state.loadedEv].concat((0, _toConsumableArray3.default)(this.state.events));

            this.setState({
                loadedEv: null,
                events: events
            }, this.loadNextEvent);

            _dispatcher2.default.dispatch({ action: 'focus_composer' });
        }
    }, {
        key: 'render',
        value: function render() {
            var _this2 = this;

            var header = null;

            if (this.state.err) {
                header = _react2.default.createElement(
                    'blockquote',
                    { className: 'mx_ReplyThread mx_ReplyThread_error' },
                    (0, _languageHandler._t)('Unable to load event that was replied to, ' + 'it either does not exist or you do not have permission to view it.')
                );
            } else if (this.state.loadedEv) {
                var ev = this.state.loadedEv;
                var Pill = _index2.default.getComponent('elements.Pill');
                var room = this.context.matrixClient.getRoom(ev.getRoomId());
                header = _react2.default.createElement(
                    'blockquote',
                    { className: 'mx_ReplyThread' },
                    (0, _languageHandler._t)('<a>In reply to</a> <pill>', {}, {
                        'a': function a(sub) {
                            return _react2.default.createElement(
                                'a',
                                { onClick: _this2.onQuoteClick, className: 'mx_ReplyThread_show' },
                                sub
                            );
                        },
                        'pill': _react2.default.createElement(Pill, { type: Pill.TYPE_USER_MENTION, room: room,
                            url: (0, _matrixTo.makeUserPermalink)(ev.getSender()), shouldShowPillAvatar: true })
                    })
                );
            } else if (this.state.loading) {
                var Spinner = _index2.default.getComponent("elements.Spinner");
                header = _react2.default.createElement(Spinner, { w: 16, h: 16 });
            }

            var EventTile = _index2.default.getComponent('views.rooms.EventTile');
            var DateSeparator = _index2.default.getComponent('messages.DateSeparator');
            var evTiles = this.state.events.map(function (ev) {
                var dateSep = null;

                if ((0, _DateUtils.wantsDateSeparator)(_this2.props.parentEv.getDate(), ev.getDate())) {
                    dateSep = _react2.default.createElement(
                        'a',
                        { href: _this2.props.url },
                        _react2.default.createElement(DateSeparator, { ts: ev.getTs() })
                    );
                }

                return _react2.default.createElement(
                    'blockquote',
                    { className: 'mx_ReplyThread', key: ev.getId() },
                    dateSep,
                    _react2.default.createElement(EventTile, { mxEvent: ev,
                        tileShape: 'reply',
                        onHeightChanged: _this2.props.onHeightChanged,
                        permalinkCreator: _this2.props.permalinkCreator,
                        isTwelveHour: _SettingsStore2.default.getValue("showTwelveHourTimestamps") })
                );
            });

            return _react2.default.createElement(
                'div',
                null,
                _react2.default.createElement(
                    'div',
                    null,
                    header
                ),
                _react2.default.createElement(
                    'div',
                    null,
                    evTiles
                )
            );
        }
    }], [{
        key: 'getParentEventId',
        value: function getParentEventId(ev) {
            if (!ev || ev.isRedacted()) return;

            // XXX: For newer relations (annotations, replacements, etc.), we now
            // have a `getRelation` helper on the event, and you might assume it
            // could be used here for replies as well... However, the helper
            // currently assumes the relation has a `rel_type`, which older replies
            // do not, so this block is left as-is for now.
            var mRelatesTo = ev.getWireContent()['m.relates_to'];
            if (mRelatesTo && mRelatesTo['m.in_reply_to']) {
                var mInReplyTo = mRelatesTo['m.in_reply_to'];
                if (mInReplyTo && mInReplyTo['event_id']) return mInReplyTo['event_id'];
            }
        }

        // Part of Replies fallback support

    }, {
        key: 'stripPlainReply',
        value: function stripPlainReply(body) {
            // Removes lines beginning with `> ` until you reach one that doesn't.
            var lines = body.split('\n');
            while (lines.length && lines[0].startsWith('> ')) {
                lines.shift();
            } // Reply fallback has a blank line after it, so remove it to prevent leading newline
            if (lines[0] === '') lines.shift();
            return lines.join('\n');
        }

        // Part of Replies fallback support

    }, {
        key: 'stripHTMLReply',
        value: function stripHTMLReply(html) {
            return html.replace(/^<mx-reply>[\s\S]+?<\/mx-reply>/, '');
        }

        // Part of Replies fallback support

    }, {
        key: 'getNestedReplyText',
        value: function getNestedReplyText(ev, permalinkCreator) {
            if (!ev) return null;

            var _ev$getContent = ev.getContent(),
                body = _ev$getContent.body,
                html = _ev$getContent.formatted_body;

            if (this.getParentEventId(ev)) {
                if (body) body = this.stripPlainReply(body);
                if (html) html = this.stripHTMLReply(html);
            }

            var evLink = permalinkCreator.forEvent(ev.getId());
            var userLink = (0, _matrixTo.makeUserPermalink)(ev.getSender());
            var mxid = ev.getSender();

            // This fallback contains text that is explicitly EN.
            switch (ev.getContent().msgtype) {
                case 'm.text':
                case 'm.notice':
                    {
                        html = '<mx-reply><blockquote><a href="' + evLink + '">In reply to</a> <a href="' + userLink + '">' + mxid + '</a>' + ('<br>' + (html || body) + '</blockquote></mx-reply>');
                        var lines = body.trim().split('\n');
                        if (lines.length > 0) {
                            lines[0] = '<' + mxid + '> ' + lines[0];
                            body = lines.map(function (line) {
                                return '> ' + line;
                            }).join('\n') + '\n\n';
                        }
                        break;
                    }
                case 'm.image':
                    html = '<mx-reply><blockquote><a href="' + evLink + '">In reply to</a> <a href="' + userLink + '">' + mxid + '</a>' + '<br>sent an image.</blockquote></mx-reply>';
                    body = '> <' + mxid + '> sent an image.\n\n';
                    break;
                case 'm.video':
                    html = '<mx-reply><blockquote><a href="' + evLink + '">In reply to</a> <a href="' + userLink + '">' + mxid + '</a>' + '<br>sent a video.</blockquote></mx-reply>';
                    body = '> <' + mxid + '> sent a video.\n\n';
                    break;
                case 'm.audio':
                    html = '<mx-reply><blockquote><a href="' + evLink + '">In reply to</a> <a href="' + userLink + '">' + mxid + '</a>' + '<br>sent an audio file.</blockquote></mx-reply>';
                    body = '> <' + mxid + '> sent an audio file.\n\n';
                    break;
                case 'm.file':
                    html = '<mx-reply><blockquote><a href="' + evLink + '">In reply to</a> <a href="' + userLink + '">' + mxid + '</a>' + '<br>sent a file.</blockquote></mx-reply>';
                    body = '> <' + mxid + '> sent a file.\n\n';
                    break;
                case 'm.emote':
                    {
                        html = '<mx-reply><blockquote><a href="' + evLink + '">In reply to</a> * ' + ('<a href="' + userLink + '">' + mxid + '</a><br>' + (html || body) + '</blockquote></mx-reply>');
                        var _lines = body.trim().split('\n');
                        if (_lines.length > 0) {
                            _lines[0] = '* <' + mxid + '> ' + _lines[0];
                            body = _lines.map(function (line) {
                                return '> ' + line;
                            }).join('\n') + '\n\n';
                        }
                        break;
                    }
                default:
                    return null;
            }

            return { body: body, html: html };
        }
    }, {
        key: 'makeReplyMixIn',
        value: function makeReplyMixIn(ev) {
            if (!ev) return {};
            return {
                'm.relates_to': {
                    'm.in_reply_to': {
                        'event_id': ev.getId()
                    }
                }
            };
        }
    }, {
        key: 'makeThread',
        value: function makeThread(parentEv, onHeightChanged, permalinkCreator, ref) {
            if (!ReplyThread.getParentEventId(parentEv)) {
                return _react2.default.createElement('div', null);
            }
            return _react2.default.createElement(ReplyThread, { parentEv: parentEv, onHeightChanged: onHeightChanged,
                ref: ref, permalinkCreator: permalinkCreator });
        }
    }]);
    return ReplyThread;
}(_react2.default.Component); /*
                              Copyright 2017 New Vector Ltd
                              
                              Licensed under the Apache License, Version 2.0 (the "License");
                              you may not use this file except in compliance with the License.
                              You may obtain a copy of the License at
                              
                                  http://www.apache.org/licenses/LICENSE-2.0
                              
                              Unless required by applicable law or agreed to in writing, software
                              distributed under the License is distributed on an "AS IS" BASIS,
                              WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
                              See the License for the specific language governing permissions and
                              limitations under the License.
                              */


ReplyThread.propTypes = {
    // the latest event in this chain of replies
    parentEv: _propTypes2.default.instanceOf(_matrixJsSdk.MatrixEvent),
    // called when the ReplyThread contents has changed, including EventTiles thereof
    onHeightChanged: _propTypes2.default.func.isRequired,
    permalinkCreator: _propTypes2.default.instanceOf(_matrixTo.RoomPermalinkCreator).isRequired
};
ReplyThread.contextTypes = {
    matrixClient: _propTypes2.default.instanceOf(_matrixJsSdk.MatrixClient).isRequired
};
exports.default = ReplyThread;
module.exports = exports['default'];
//# sourceMappingURL=ReplyThread.js.map